// extracted by mini-css-extract-plugin
export default {"section":"PopularRequests_section__QXEQW","grid":"PopularRequests_grid__KpsdD","item":"PopularRequests_item__8JZvd","arrow":"PopularRequests_arrow__h6qrg"};